module.exports = __webpack_public_path__ + "static/media/24-f-piano.7213dac6.svg";